/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
export type DeleteLabelInput = {|
  id: string,
  csrfToken?: ?string,
  socketClientId?: ?string,
  clientMutationId?: ?string,
|};
export type deleteLabelMutationVariables = {|
  input: DeleteLabelInput
|};
export type deleteLabelMutationResponse = {|
  +deleteLabel: ?{|
    +deletedLabelId: ?string
  |}
|};
export type deleteLabelMutation = {|
  variables: deleteLabelMutationVariables,
  response: deleteLabelMutationResponse,
|};
*/


/*
mutation deleteLabelMutation(
  $input: DeleteLabelInput!
) {
  deleteLabel(input: $input) {
    deletedLabelId
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input",
    "type": "DeleteLabelInput!"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "DeleteLabelPayload",
    "kind": "LinkedField",
    "name": "deleteLabel",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "deletedLabelId",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "deleteLabelMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "deleteLabelMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "id": null,
    "metadata": {},
    "name": "deleteLabelMutation",
    "operationKind": "mutation",
    "text": "mutation deleteLabelMutation(\n  $input: DeleteLabelInput!\n) {\n  deleteLabel(input: $input) {\n    deletedLabelId\n  }\n}\n"
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = '91e3b5764b3c66584b6dde30d6a8780e';

module.exports = node;
